import dayjs from "dayjs";

export default {
  formatDate(t, p = "YYYY-MM-DD HH:mm:ss") {
    return dayjs(t).format(p);
  },
  isToday(s) {
    return dayjs(s).isSame(new Date(), "day");
  }
};
